var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 10.8661C15.75 14.3486 19.6334 18.0171 22.8369 20.451C24.6349 21.817 25.5339 22.5 27 22.5C28.4661 22.5 29.3651 21.817 31.1631 20.451C34.3667 18.0172 38.25 14.3486 38.25 10.866C38.25 4.58815 32.0623 2.24429 27 7.09391C21.9377 2.24429 15.75 4.58815 15.75 10.8661Z",
    fill: "#A37FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.0849 48.1239H13.5C11.3787 48.1239 10.318 48.1239 9.65901 47.4649C9 46.8058 9 45.7452 9 43.6239V41.122C9 39.9554 9 39.372 9.29965 38.8511C9.5993 38.3302 10.0514 38.0672 10.9555 37.5414C16.9078 34.0795 25.361 32.1307 31.0029 35.4958C31.382 35.7219 31.7229 35.9948 32.0142 36.322C33.2699 37.7325 33.1784 39.8612 31.7312 41.1244C31.4256 41.3911 31.0998 41.5934 30.7718 41.6637C31.0414 41.6325 31.2998 41.5966 31.5463 41.5573C33.5969 41.2302 35.3183 40.1344 36.8942 38.944L40.9604 35.8723C42.3939 34.7895 44.5214 34.7893 45.9552 35.8718C47.2459 36.8464 47.6406 38.4512 46.8246 39.7592C45.873 41.2845 44.5322 43.2359 43.2448 44.4283C41.9556 45.6224 40.0362 46.6884 38.4693 47.4447C36.7336 48.2825 34.816 48.7652 32.8656 49.0809C28.9099 49.7213 24.7873 49.6235 20.8717 48.8169C18.6582 48.3608 16.3593 48.1239 14.0849 48.1239Z",
    fill: "#A37FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValues);
export default __webpack_public_path__ + "static/media/Values.12722ed5a694a6324892767a3b885081.svg";
export { ForwardRef as ReactComponent };